export default "__VITE_ASSET__CsWNr304__"